import React from 'react'
import { theme } from 'theme'
import Icon from 'components/Icon'
import Text, { TextScale } from 'particles/Text'
import { IconTextContainer } from './styles'

interface DateIconTextProps {
    text: string
    textType?: TextScale
}

const DateIconText: React.FC<DateIconTextProps> = ({ text, textType = 'bodyS400' }) => {
    return (
        <IconTextContainer>
            <div className="icon">
                <Icon.CalendarBlankIcon color={theme.newColors.neutral500} />
            </div>
            <Text scale={textType} color="secondary">
                {text}
            </Text>
        </IconTextContainer>
    )
}

export default DateIconText
